// @flow

const config = {
  name: process.env.NAME,
  baseName: process.env.BASE_NAME || '',
  oldDomainUrl: process.env.OLD_DOMAIN_URL,
  oldReactDomainUrl: process.env.OLD_REACT_DOMAIN_URL,
  zoomApiUrl: process.env.ZOOM_API_URL,
  clientIntegrationApiUrl: process.env.CLIENT_INTEGRATION_API_URL,
  loginUrl: process.env.LOGIN_URL,
  login: process.env.LOGIN,
  logoutUrl: process.env.LOGOUT_URL,
  zoomCommunicationsEp: process.env.ZOOM_COMMUNICATIONS_EP,
  analyticsFlag: process.env.ANALYTICS_FLAG,
  analyticsId: process.env.ANALYTICS_ID,
  ga4AnalyticsId: process.env.GA4_ANALYTICS_ID,
  ticketingUrl: process.env.TICKETING_URL,
  zoomSuperSetUrl: process.env.ZOOM_SUPER_SET_URL,
  developerUrl: process.env.DEVELOPER_URL,
  zoomWmsBaseUrl: process.env.ZOOM_WMS_BASE_URL,
  vendorContractUrl: process.env.VENDOR_CONTRACT_URL,
  eRetailUrl: process.env.E_RETAIL_URL,
  crmOzoneTelCall: process.env.CRM_OZONE_TEL_CALL,
  crmGoogleForm: process.env.CRM_GOOGLE_FORM,
  mapBoxAccessToken: process.env.MAP_BOX_ACCESS_TOKEN,
  shipUrl: process.env.SHIP_URL,
  mllAirClientCode: process.env.MLL_AIR_CLIENT_CODE,
  envioroment: process.env.NODE_ENV,
  deploymentEnvType: process.env.NODE_NAMESPACE
};

export default config;
